import { useState } from 'react'
import { useEcustomsSettings } from '../../hooks/useEcustomsSettings'

// Z73.5: the one Admin control for the eCustoms (Descartes) Download-first workflow -- off by
// default, so the eCustoms Preview page only offers "Download API Files" for manual upload to
// Descartes UAT. Flip this on once those manually-uploaded files are confirmed working, and the
// "Submit to Descartes UAT" button (already built, real SOAP call) becomes usable directly from
// the app. Production submit is a deliberately separate, later step -- it stays disabled
// regardless of this toggle (see ECustomsPreview.tsx).
export default function EcustomsSettings() {
  const { uatVerified, loading, setUatVerified } = useEcustomsSettings()
  const [saving, setSaving] = useState(false)

  async function handleToggle() {
    setSaving(true)
    await setUatVerified(!uatVerified)
    setSaving(false)
  }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">eCustoms (Descartes) Settings</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Controls whether staff can submit declarations to Descartes directly from the app, or must download the files and upload them to Descartes UAT manually.
        </p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Loading...</div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={uatVerified}
              onChange={handleToggle}
              disabled={saving}
              className="mt-1 w-4 h-4"
            />
            <div>
              <p className="font-semibold text-gray-800 dark:text-gray-200">Descartes UAT verified → enable API submit</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Off by default: the eCustoms Preview page only offers "Download API Files" so staff can upload them to Descartes UAT
                through Descartes' own web interface. Turn this on once you've confirmed those manually-uploaded files work correctly --
                that enables the "Submit to Descartes UAT" button, so staff can submit directly from the app instead of downloading and
                uploading by hand.
              </p>
            </div>
          </label>
          <p className="mt-4 text-xs text-amber-600 dark:text-amber-400">
            Production submit is a separate, later step -- it stays disabled regardless of this toggle until you explicitly ask for it to be enabled.
          </p>
        </div>
      )}
    </div>
  )
}
